import React, { ComponentProps, useState, SetStateAction, useEffect } from 'react';
import ReactRouterDOM, { useLocation, Link } from 'react-router-dom'; //{ BrowserRouter as Router, Switch, Route, useParams } from 'react-router-dom';
import { Menu, Transition, Icon, Popup, Dropdown } from 'semantic-ui-react';
import Button from './elements/Button';
import SideBar from './SideBar';
import { useSelector } from 'react-redux';
import { setUser } from '../store/reducers/ui/actions';
import useAuth from '../utils/customHooks/useAuth';
import SimplicityIcon from '../assets/images/Simplicity-Icon-Light.png';

const Layout = ({children}:LayoutParams):React.ReactElement => {
	/// Hooks
	const auth = useAuth();

	/// Global State
	const customer = useSelector(state => state.ui.customer);
	const user = useSelector(state => state.ui.user);
	const client = useSelector(state => state.ui.client);

	/// Events
	const handleLogOutClick = (e) => {
		auth.signOut();
	};

	/// Local Variables
	const sideBarIcons = React.useMemo(() => [
		{
			routeTo: '/Accounts',
			tooltip: 'Account Search',
			iconName: 'search'
		},
		{
			routeTo: '/EnterAccounts',
			tooltip: 'Enter Accounts',
			iconName: 'user plus'
		},
		{
			routeTo: '/Reports',
			tooltip: 'Reports',
			iconName: 'signal'
		},
		// {
		// 	routeTo: '/Reminders',
		// 	tooltip: 'Reminders',
		// 	iconName: 'bell outline'
		// },
		{
			tooltip: 'Upload',
			iconName: 'file alternate outline',
			subMenu: [
				{
					routeTo: '/UploadToAccount',
					tooltip: 'Upload to Account',
					iconName: 'user circle outline'
				},
				{
					routeTo: '/UploadToAgency',
					tooltip: `Upload to ${customer.customerName}`,
					iconName: 'upload'
				}
			]
		}
	], [customer.customerName]);

	/// Render
	return (
		<div className="client-portal-body">
			<div
				className="header"
				style={{
					backgroundColor: customer.primaryColor,
					borderBottomColor: customer.secondaryColor
				}}
			>
				<img src={customer.logoUrl} className="header-logo" />
				<h1 className="header-title">{client ? (client.fullName || client.name) : 'Client'} Portal</h1>
				<div className="header-user-menu">
					<Dropdown text={user.username} as={Button} primary>
						<Dropdown.Menu>
							<Dropdown.Item text="Log Out" onClick={handleLogOutClick} />
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</div>
			<div className="side-bar">
				<SideBar menuItems={sideBarIcons} />
				<Popup
					content="Powered by Simplicity Collect"
					position="right center"
					trigger={
						<a
							style={{
								backgroundColor: '#404040',
								color: '#ffffff',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								fontSize: '.6em',
								paddingTop: '1em'
							}}
							target="#"
							href="https://www.simplicitycollectionsoftware.com/"
						>
							<img src={SimplicityIcon} />
							Powered by
						</a>
					}
				/>
			</div>
			<div className="page-body">
				{children}
			</div>
		</div>
	);
};

interface LayoutParams {
	children:any;
}

export default Layout;